import AppConfig from "../../app.config";
import Session from "./Session";
import { toasts } from "svelte-toasts";
export default class Employee {
    static async getAll() {
        const token = Session.getToken();
        const res = await fetch(`${AppConfig.REST.URL}/employee/?token=${token}`);
        const json = await res.json();
        return json;
    }
    static async getDetails(_id) {
        const id = _id || Session.getToken();
        const token = Session.getToken();
        const res = await fetch(`${AppConfig.REST.URL}/employee/${id}?token=${token}`);
        const json = await res.json();
        return json;
    }
    static async getPurchases(_id, dateStart, dateEnd) {
        const id = _id || Session.getToken();
        const token = Session.getToken();
        const dateQuery = `${dateStart ? `&dateStart=${dateStart}` : ''}${dateEnd ? `&dateEnd=${dateEnd}` : ''}`;
        const res = await fetch(`${AppConfig.REST.URL}/employee/${id}/purchases?token=${token}${dateQuery}`);
        const json = await res.json();
        return json;
    }
    static async getPurchasesSummary(_id, dateStart, dateEnd) {
        const id = _id || Session.getToken();
        const token = Session.getToken();
        const dateQuery = `${dateStart ? `&dateStart=${new Date(dateStart).getTime()}` : ''}${dateEnd ? `&dateEnd=${new Date(dateEnd).getTime()}` : ''}`;
        const res = await fetch(`${AppConfig.REST.URL}/employee/${id}/purchases/summary?token=${token}${dateQuery}`);
        const json = await res.json();
        return json;
    }
    static async add(data) {
        const token = Session.getToken();
        const { pin, firstname, lastname, phone, email, role } = data;
        const body = new URLSearchParams();
        body.append("pin", pin);
        body.append("firstname", firstname);
        body.append("lastname", lastname);
        body.append("phone", phone);
        body.append("email", email);
        body.append("role", role);
        body.append("token", token);
        const res = await fetch(`${AppConfig.REST.URL}/employee?token=${token}`, { method: 'POST', body });
        const json = await res.json();
        if (res.status == 201) {
            toasts.success(`Sukces`, `Pracownik ${json.firstname} ${json.lastname} został pomyślnie dodany! Wysłaliśmy SMS pod numer ${json.phone}.`);
        }
        else if (res.status == 409) {
            toasts.error(`Uwaga`, `Nie mogliśmy dodać użytkownika, gdyż istnieje już jeden z podanym numerem telefonu (${json.details})`);
        }
        else if (res.status == 500) {
            toasts.error(`Uwaga`, `Sprawdź pola formularza i spróbuj ponownie.`);
        }
        return json;
    }
    static async setRole(employee, role) {
        const token = Session.getToken();
        const body = new URLSearchParams();
        body.append("role", role);
        const res = await fetch(`${AppConfig.REST.URL}/employee/${employee}?token=${token}`, { method: 'PUT', body });
        const json = await res.json();
        if (res.status == 200)
            toasts.success(`Sukces`, `Rola pracownika ${json.firstname} została zaktualizowana.`);
        return json;
    }
    static async remindPIN(phone) {
        const token = Session.getToken();
        const body = new URLSearchParams();
        body.append("phone", phone);
        const res = await fetch(`${AppConfig.REST.URL}/employee/remind`, { method: 'POST', body });
        const json = await res.json();
        if (res.status == 200)
            toasts.info(`Informacja`, `Jeżeli numer telefonu istnieje w systemie, wysłaliśmy wiadomość z numerem PIN.`);
        return json;
    }
}
